module.exports = __webpack_public_path__ + "img/blue-caret-up.7f6cca24.svg";